import { Injectable, inject } from '@angular/core';
import { CommonUtilsService } from '@bepatient/common';
import {
  selectorMyEdiary,
  selectorMyEdiaryPending,
  selectorMySelectedEdiary
} from '@bepatient/my-ediary-store';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { format } from 'date-fns';
import {
  CorePageModuleIDs,
  CoreRouterActionNavigateToPageModule,
  CoreRouterNavigationIntent
} from '@bepatient/core';

@Injectable()
export class EdiaryUtilsService {
  private utils = inject(CommonUtilsService);

  currentDateSource$ = new BehaviorSubject<any>({});
  currentDate$ = this.currentDateSource$.asObservable();

  vm$ = combineLatest([
    this.utils.instanceColor$,
    this.utils.storeSelect(selectorMyEdiary),
    this.utils.storeSelect(selectorMyEdiaryPending),
    this.currentDate$
  ]).pipe(
    map(([color, ediary, loading, todayDateObj]) => ({
      ediary,
      color,
      loading,
      todayDateObj
    }))
  );

  ediaryDetail$ = combineLatest([
    this.utils.instanceColor$,
    this.utils.storeSelect(selectorMySelectedEdiary)
  ]).pipe(
    map(([color, selectedEdiary]) => ({
      selectedEdiary,
      color
    }))
  );

  constructor() {
    let currentDate = new Date();
    this.currentDateSource$.next({
      year: format(currentDate, 'yyyy'),
      month: format(currentDate, 'MM'),
      monthName: format(currentDate, 'MMM'),
      day: format(currentDate, 'dd')
    });
  }

  openMenu() {
    this.utils.storeDispatch(
      new CoreRouterActionNavigateToPageModule({
        id: CorePageModuleIDs.MENU,
        pageIndex: 0,
        intent: CoreRouterNavigationIntent.FORWARD
      })
    );
  }
}
